export default __webpack_public_path__ + "static/media/Danshwaraj-Chaudhary.bff2471e.jpg";